export default __webpack_public_path__ + "static/media/digitalImage.5b11137d.jpg";